import React from 'react';
import { InputText } from '../input-text';
import { Button } from '../button';

type PhoneEditorProps = {
    phone: string;
    setPhone: (value: string) => void;
};

function validatePhoneFormat(phoneNumber: string): boolean {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    return !phoneRegex.test(phoneNumber);
}

export const PhoneEditor = ({ phone, setPhone }: PhoneEditorProps) => {
    const [phoneNumber, setPhoneNumber] = React.useState(phone);
    const [isEditing, setIsEditing] = React.useState(false);

    React.useEffect(() => {
        setPhoneNumber(phone);
    }, [phone]);

    const onCancel = () => {
        setPhoneNumber(phone);
        setIsEditing(false);
    };

    const savePhoneNumber = () => {
        setPhone(phoneNumber);
        setIsEditing(false);
    };

    return (
        <div>
            <div>
                {isEditing ? (
                    <div>
                        <span>*Must be in the format XXX-XXX-XXXX</span>
                        <InputText
                            value={phoneNumber}
                            setValue={setPhoneNumber}
                        />
                    </div>
                ) : (
                    phoneNumber
                )}
            </div>
            {isEditing ? (
                <div className="buttons_holder">
                    <Button variant="secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={savePhoneNumber}
                        disabled={validatePhoneFormat(phoneNumber)}
                    >
                        Confirm
                    </Button>
                </div>
            ) : (
                <div className="buttons_holder">
                    <Button
                        variant="secondary"
                        onClick={() => setIsEditing(true)}
                    >
                        Edit
                    </Button>
                </div>
            )}
        </div>
    );
};
